import styles from './Container.module.scss'

type IContainer = {
  children: any
}

const Container = ({children}: IContainer) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  )
}

export default Container;